{
	"title": "Termeni și condiții",
	"backTitle": "Înapoi"
}
